import { GlobalStoreContextType } from "../context/GlobalStoreContext";
import { GateToDropoffRouteModel } from "./GateToDropoffRoute.model";
import { MapObject } from "./MapObject";

export class GateToDropoffRoute extends GateToDropoffRouteModel {
    static fromFeature(
        feature: GeoJSON.Feature,
        project: any,
        gateId: number,
        dropoffId: number,
        name: string,
        timezone: string
    ): GateToDropoffRoute {
        return GateToDropoffRoute.fromApiObject(
            {
                id: null,
                project_id: project.id,
                gate_id: gateId,
                dropoff_id: dropoffId,
                name,
            },
            timezone
        );
    }

    getMapObject(globalStoreContext: GlobalStoreContextType): MapObject | null {
        const projectMapObjects = globalStoreContext.mapObjectsForProject(this.projectId || "");

        const mapObject = projectMapObjects.find(
            (mapObject) => mapObject.mappableType == "GateToDropoffRoute" && mapObject.mappableId == this.id
        );

        if (mapObject) {
            return mapObject;
        }

        return null;
    }
}
